import React, { useState } from 'react'
import Text from '../Text'
import { ReactComponent as EyeOn } from 'assets/icons/eye-on.svg'
import { ReactComponent as EyeOff } from 'assets/icons/eye-off.svg'

const Password = ({
  value,
  label,
  placeholder,
  onChange,
  size,
  error,
  autoComplete,
}) => {

  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => setShowPassword(prev => !prev)

  return (
    <Text
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      size={size}
      error={error}
      iconRight={showPassword ? EyeOn : EyeOff}
      iconRightClick={toggleShowPassword}
      type={showPassword ? 'text' : 'password'}
      autoComplete={autoComplete}
    />
  )
}

export default Password